const CLIENT_VERSION = "1.00";
  
export default CLIENT_VERSION;